import ButtonContainer from '@kiosk/common/components/Forms/ButtonContainer';
import Button from '@kiosk/common/components/Button';
import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';
import { useAutomatedBreaksContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/AutomatedBreaksProvider';

type Props = { shortenAnimations: boolean };

const ButtonsOnBreakState = ({ shortenAnimations }: Props) => {
  const {
    isIntegrationKiosk,
    endBreak,
    signOut,
    clockOut,
    timeClockNoteRef
  } = useClockedInViewContext();
  const {
    setAutomatedBreakScreen,
    canFinishAutomatedBreak,
    missedBreaks
  } = useAutomatedBreaksContext();

  let delay = shortenAnimations ? 0 : 1;
  delay = delay + 0.4;

  const handleEndBreak = () => {
    if (!canFinishAutomatedBreak()) {
      setAutomatedBreakScreen('backTooSoon');
    } else {
      endBreak();
      timeClockNoteRef.current?.saveNote();
    }
  };

  const handleClockOut = () => {
    if (missedBreaks) {
      setAutomatedBreakScreen('attestation');
    } else {
      clockOut();
      timeClockNoteRef.current?.saveNote();
    }
  };

  return (
    <ButtonContainer delay={delay}>
      <Button
        label="End break"
        buttonTheme="grey"
        themeColor="btnBreakTextColor"
        onPress={handleEndBreak}
      />
      <Button
        label="Clock out"
        buttonTheme="grey"
        themeColor="errorTextColor"
        onPress={handleClockOut}
        withMargin
      />
      {!isIntegrationKiosk && (
        <Button label="Cancel" buttonTheme="grey" onPress={signOut} withMargin />
      )}
    </ButtonContainer>
  );
};

export default ButtonsOnBreakState;
